export type OrderTabId = 'details' | 'scans';

export const ORDER_TABS: readonly { id: OrderTabId; label: string }[] = [
    { id: 'details', label: 'Details' },
    { id: 'scans', label: 'Scans' }
];

export const orderTabId = (baseId: string, tab: OrderTabId) => `${baseId}-order-tab-${tab}`;
export const orderPanelId = (baseId: string, tab: OrderTabId) => `${baseId}-order-panel-${tab}`;

export function nextOrderTab(current: OrderTabId, step: 1 | -1): OrderTabId {
    const index = ORDER_TABS.findIndex((tab) => tab.id === current);
    const count = ORDER_TABS.length;
    return ORDER_TABS[(index + step + count) % count].id;
}
